// extracted by extract-css-chunks-webpack-plugin
module.exports = {"filter-actions":"filter-award-registration-approval__filter-actions--ZND7A","filterActions":"filter-award-registration-approval__filter-actions--ZND7A"};